import React from 'react'
import PropTypes from 'prop-types'

// components
import { Input } from '@st-operations/uikit/src/v2/index.js'

// lib
import pretty from '@st-operations/uikit/lib/pretty'

const AudienceForm = ({ fields, handleChange, values }) => {
  return (
    <>
      <div className="audience__fields-wrapper">
        <For each="field" of={fields}>
          <Choose>
            <When condition={field.type === 'text'}>
              <Input
                key={field.name}
                name={field.name}
                label={field.label ?? pretty(field.name)}
                value={values[field.name]}
                onChange={(value) => handleChange(field, value)}
                description={field.description ?? ''}
                containerStyle={{ gridColumn: field.position }}
                disabled={field.disabled}
              />
            </When>
          </Choose>
        </For>
      </div>
    </>
  )
}

AudienceForm.propTypes = {
  fields: PropTypes.array,
  values: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
}

export default AudienceForm
